import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import MoneyFormatter from '../../../commons/componentes/MoneyFormatter';
import DateFormat from '../../../commons/componentes/DateFormat';

const ServicioAsignadoTable = (props: any) => {

    const { grupoId, empresaId, empresaServicios, seleccionarEmpresa }: { grupoId: string; empresaId: string, empresaServicios: any[], seleccionarEmpresa?: any } = props;

    const dispatch = useDispatch();


    console.log('App loading');



    return (
        <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table tabla-chica" style={{ minWidth: 520 }}>
                <thead>
                    <tr className='bg-primary'>
                        <th>Inicio de Servicio</th>
                        <th>Proveedor</th>
                        <th>Se Factura a</th>
                        <th>Servicio</th>
                        <th>Último Precio</th>
                        <th>Precio</th>
                    </tr>
                </thead>
                <tbody>
                    {empresaServicios.map((servicioAsignado, index: number) => (
                        <tr key={servicioAsignado.id ?? index}
                            className={servicioAsignado.id === Number(empresaId) ? "selected" : ""}
                        >
                            <td><DateFormat value={servicioAsignado.seraInicio}></DateFormat></td>
                            <td>{servicioAsignado.cmpProveedor}</td>
                            <td>{servicioAsignado.empRazonSocialFactura}</td>
                            <td>{servicioAsignado.servDescripcion}</td>
                            <td><DateFormat value={servicioAsignado.fechaPrecio}></DateFormat></td>
                            <td><MoneyFormatter value={servicioAsignado.ultimoPrecio}></MoneyFormatter></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ServicioAsignadoTable;
